import { matchPath, useLocation } from 'react-router-dom';

import routes from '@/shared/routes';

export const useMatchedRoute = () => {
  const { pathname } = useLocation();
  return routes.find((route) => matchPath({ path: route.path }, pathname));
};
